module.exports = __webpack_public_path__ + "img/1571318030.994f4df6.jpg";